import React, { useMemo } from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';

export default function numArrow(props: any) {
  // numContent:‘90%,0,1000’（3种情况），不能包含负号
  // numSize: 'big,small, zero,new'（4种情况）;bigs说明数值为正数，small说明数值为负数-只是用于标识
  // numColor: 'errorColor，successColor，grayColo'（3种情况）
  // arrow: true or false （2种情况）
  // arrowColor: 'trendUp,trendDown,grayUp,grayDown'（4种情况）
  const { dataContent = {}, type } = props;
  const { numContent, numSize, numColor, arrow, arrowColor, isShowZero = false } = dataContent;

  // console.log('numArrow', props);

  const newNumColor = useMemo(() => {
    switch (numColor) {
      case 'successColor':
        return 'num-green';
      case 'warningColor':
        return 'num-warning';
      case 'errorColor':
        return 'num-red';
      case 'grayColor':
      default:
        return 'num-text';
    }
  }, [numColor]);

  const newArrowColor = useMemo(() => {
    switch (arrowColor) {
      case 'trendUp':
        return 'green-up-new';
      case 'trendDown':
        return 'red-down-new';
      case 'grayUp':
        return 'rising-arrow-icon';
      case 'grayDown':
        return 'down-arrow-icon';
      default:
        return type == 'rank' ? 'down-arrow-icon' : 'icon';
    }
  }, [arrowColor]);

  return (
    <>
      <div className="num-flex">
        {/* 显示数值 */}
        {!numContent && <span className="num-gray">-</span>}
        {/**环比为0展示- */}
        {numContent && numSize == 'zero' && <span className="num-gray" style={{lineHeight: isShowZero ? '14px' : '16px'}}>{isShowZero ? numContent : '-'}</span>}
        {numContent && numSize == 'big' && (
          <span className={newNumColor}>{numContent}</span>
        )}
        {numContent && numSize == 'small' && (
          <span className={newNumColor}>{numContent}</span>
        )}
        {numSize == 'new' && <span className={newNumColor}>New</span>}
        {/* 显示图标 */}
        {arrow && numContent && numSize != 'new' && (//numContent没有值的时候不展示箭头
          <>
            {/* 另外使用icon bottom-green */}
            <SvgIcon type={newArrowColor} className={type == 'rank' ? 'rank-flex-icon' : 'num-icon'} />
          </>
        )}
        {
          // 当arrow为false时，不显示箭头
          (!arrow || numSize == 'new') && (
            <>
              {' '}
              <span className="num-text"></span>
            </>
          )
        }
      </div>
    </>
  );
}
